var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFundingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5250_30248",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 24,
    width: 24,
    height: 24,
    transform: "rotate(-180 24 24)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5250_30248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 15L16.2885 10.7115L15.6 10.023L12.5 13.0787L12.5 3.423L11.5 3.423L11.5 13.0787L8.4 10.023L7.7115 10.7115L12 15ZM19.8308 7.59625C20.2103 8.27175 20.5 8.97966 20.7 9.72C20.9 10.4602 21 11.2202 21 12C21 13.245 20.7638 14.415 20.2915 15.51C19.8192 16.605 19.1782 17.5575 18.3685 18.3675C17.5588 19.1775 16.6067 19.8188 15.512 20.2913C14.4175 20.7637 13.2479 21 12.0033 21C10.7587 21 9.58867 20.7637 8.493 20.2912C7.3975 19.8187 6.4445 19.1775 5.634 18.3675C4.8235 17.5575 4.18192 16.605 3.70925 15.51C3.23642 14.415 3 13.245 3 12C3 11.2202 3.1 10.4602 3.3 9.72C3.5 8.97966 3.78975 8.27175 4.16925 7.59625L4.8885 8.3155C4.58583 8.9065 4.36208 9.50791 4.21725 10.1197C4.07242 10.7316 4 11.3583 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 11.3475 19.9243 10.7105 19.773 10.089C19.6218 9.4675 19.3949 8.87633 19.0923 8.3155L19.8308 7.59625Z",
    fill: "#107569"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFundingsIcon);
export default __webpack_public_path__ + "static/media/fundings-icon.c07a1da6a4d47882dc6d836f5c9ca957.svg";
export { ForwardRef as ReactComponent };